
const About = ({ successHandler }) => {
  const apiBase = (process.env.REACT_APP_USER_API_URL || '').replace(/\/$/, '');

  const teamMembers = [
    {
      name: 'Dr. Inna Tolskaya',
      role: 'Product & Linguistics',
      image: 'it.jpg',
      expertise:
        'Linguist, project manager, and software developer with experience in language technology and e-learning.',
      projects: [
        {
          name: 'EasyRights',
          url: 'http://www.easyrights.polimi.it/',
          description:
            'A platform helping immigrants understand and use their rights with language support.',
        },
        {
          name: 'Capeesh',
          url: 'https://www.capeesh.com/',
          description:
            'Interactive language-learning app with courses and pronunciation practice.',
        },
      ],
    },
    {
      name: 'Associate Professor Olaf Husby',
      role: 'Teaching & Didactics',
      image: 'oh.jpg',
      expertise:
        'Pronunciation specialist, second language educator, course developer, and Norwegian dialect expert.',
      projects: [
        {
          name: 'NOW',
          url: 'https://www.ntnu.edu/now/',
          description:
            'Free beginner Norwegian course with texts, audio, and exercises.',
        },
        {
          name: 'NOW2',
          url: 'https://www.ntnu.edu/now2',
          description:
            'Intermediate Norwegian course for learners with previous knowledge.',
        },
        {
          name: 'CALST',
          url: 'https://www.ntnu.edu/isl/calst',
          description:
            'Pronunciation training platform with listening and speaking exercises.',
        },
        {
          name: 'L1-L2 Map',
          url: 'https://l1-l2map.it.ntnu.no/',
          description:
            'Tool comparing sounds across languages to show what learners may need to practise.',
        },
      ],
    },
    {
      name: 'Dr. Dmitry Shcherbin',
      role: 'Technology & Research',
      image: 'ds.jpg',
      expertise: 'Product developer and researcher',
      projects: [
        {
          name: 'CALST',
          url: 'https://www.ntnu.edu/isl/calst',
          description:
            'Research-based pronunciation training system for language learners.',
        },
        {
          name: 'Pygmalion',
          url: 'https://pygmalion.hf.ntnu.no/',
          description:
            'Research prototype for multilingual pronunciation training.',
        },
        {
          name: 'EasyRights',
          url: 'http://www.easyrights.polimi.it/',
          description:
            'Platform helping immigrants understand their rights.',
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-stone-50 text-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {successHandler && (
          <button
            type="button"
            onClick={() => successHandler(false)}
            className="mb-5 inline-flex items-center rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-black text-slate-700 shadow-sm transition hover:-translate-y-0.5 hover:bg-slate-50 hover:shadow-md"
          >
            ← Back
          </button>
        )}

        <main className="relative overflow-hidden rounded-[38px] border border-slate-200 bg-white shadow-2xl shadow-slate-200/70">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.09),transparent_34%),radial-gradient(circle_at_92%_8%,rgba(16,185,129,0.08),transparent_28%)]" />
          <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(15,23,42,0.035)_1px,transparent_1px),linear-gradient(to_bottom,rgba(15,23,42,0.03)_1px,transparent_1px)] bg-[size:44px_44px] opacity-35" />

          <div className="relative">
            {/* Hero */}
            <section className="px-5 py-14 md:px-10 md:py-20">
              <div className="mx-auto max-w-5xl">
                <div className="max-w-4xl">
                  <SectionBadge tone="blue">About Catchphraser</SectionBadge>

                  <h1 className="mt-6 max-w-4xl text-4xl font-black tracking-tight text-slate-950 md:text-6xl md:leading-[1.03]">
                    Pronunciation should not be left to chance.
                  </h1>

                  <p className="mt-7 max-w-3xl text-base font-medium leading-8 text-slate-600 md:text-xl md:leading-9">
                    Language learners are usually taught vocabulary and grammar.
                    Pronunciation is often treated as something they will simply
                    pick up. Catchphraser was built for that missing layer:
                    rhythm, stress, intonation, connected speech, and
                    articulation.
                  </p>

                  <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                    <a
                      href="/howto"
                      className="inline-flex items-center justify-center rounded-2xl bg-blue-700 px-6 py-3.5 text-sm font-black text-white no-underline shadow-lg shadow-blue-700/25 transition hover:-translate-y-0.5 hover:bg-blue-800 hover:shadow-xl"
                    >
                      See how practice works
                    </a>

                    <a
                      href="#team"
                      className="inline-flex items-center justify-center rounded-2xl border border-slate-300 bg-white px-6 py-3.5 text-sm font-black text-slate-800 no-underline shadow-sm transition hover:-translate-y-0.5 hover:bg-slate-50 hover:shadow-md"
                    >
                      Meet the team
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* Quote */}
            <section className="px-5 pb-6 md:px-10 md:pb-8">
              <div className="mx-auto max-w-5xl">
                <figure className="relative overflow-hidden rounded-[32px] border border-blue-100 bg-white/90 p-6 shadow-sm backdrop-blur md:p-9">
                  <div className="absolute -right-10 -top-12 text-[160px] font-black leading-none text-blue-100/70">
                    ”
                  </div>

                  <div className="relative grid gap-7 md:grid-cols-[0.34fr_1fr] md:items-start">
                    <div>
                      <SectionBadge tone="blue">A useful warning</SectionBadge>

                      <div className="mt-4 text-xs font-black uppercase tracking-[0.2em] text-slate-400">
                        O’Connor & Arnold
                      </div>
                    </div>

                    <div className="border-l-4 border-blue-700 pl-6 md:pl-8">
                      <blockquote>
                        <p className="text-2xl font-black leading-9 tracking-tight text-slate-950 md:text-3xl md:leading-10">
                          “There are some gifted people who can acquire the
                          tunes of English by simply imitating what they hear
                          around them, but most foreign students cannot do this
                          and would be unwise to think that they can.”
                        </p>
                      </blockquote>

                      <figcaption className="mt-6 max-w-2xl border-t border-blue-100 pt-5 text-sm font-semibold leading-6 text-slate-600">
                        From{' '}
                        <span className="font-black text-slate-800">
                          Intonation of Colloquial English
                        </span>
                        .
                      </figcaption>
                    </div>
                  </div>
                </figure>
              </div>
            </section>

            {/* Approach */}
            <TextSection
              badge="Our approach"
              title="Structured practice around human-read model phrases."
            >
              <p>
                Catchphraser is built around human-read model material and
                short, repeatable exercises. Learners listen, record, compare,
                and return to difficult patterns over time.
              </p>

              <p>
                Echoing and shadowing reduce the cognitive load of speech
                production: learners do not have to invent what to say, and can
                focus more directly on rhythm, stress, timing, intonation, and
                articulation.
              </p>

              <p>
                Visual cues help learners notice speech patterns. AI-supported
                feedback and human feedback help them choose what to practise
                next, making feedback part of a repetition loop rather than a
                one-time correction.
              </p>
            </TextSection>

            {/* Course example */}
            <TextSection
              tone="blue"
              badge="Course example"
              title="Flyt og rytme: sentence-level pronunciation."
              action={
                <a
                  href="https://www.catchphraser.com/course/flyt-og-rytme"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-7 inline-flex rounded-2xl bg-blue-700 px-5 py-3 text-sm font-black text-white no-underline shadow-sm transition hover:-translate-y-0.5 hover:bg-blue-800 hover:shadow-md"
                >
                  Open Flyt og rytme
                </a>
              }
            >
              <p>
                Flyt og rytme is a Norwegian pronunciation course developed by
                Associate Professor Olaf Husby. The course consists of 40
                exercises that train learners to manage stress timing in
                Norwegian.
              </p>

              <p>
                The focus is sentence-level pronunciation: clear stressed
                syllables, correct vowel length under stress, compressed and
                relatively flat weak syllables, tonal movement near stress, and
                an unbroken speech chain.
              </p>

              <p>
                In examples such as{' '}
                <span className="font-black text-slate-950">
                  KAri‿SNAKKer
                </span>
                ,{' '}
                <span className="font-black text-slate-950">
                  SØLvi‿vil‿ikke‿STAve
                </span>
                , and{' '}
                <span className="font-black text-slate-950">
                  har‿du‿akkurat‿kommet‿HJEM?
                </span>
                , learners work with rhythm, compression, chaining, and the
                placement of the main tonal event.
              </p>
            </TextSection>

            {/* Students and teachers */}
            <TextSection
              badge="For students and teachers"
              title="Speaking is a human activity."
            >
              <p>
                Catchphraser introduces a social peer-review layer for
                pronunciation practice. A learner can ask another student or a
                teacher to review a recorded phrase and comment on what they
                hear.
              </p>

              <p>
                We believe this kind of social collaboration is especially
                useful for pronunciation. Speech is not only a score or a curve
                on a screen; it is something people hear, interpret, and respond
                to.
              </p>

              <p>
                We hope this portal will be useful both for students and for
                teachers. If you have ideas, feedback, or would like to
                collaborate, please contact us at{' '}
                <a
                  href="mailto:info@catchphraser.com"
                  className="font-black text-blue-700 underline decoration-blue-300 underline-offset-4 hover:text-blue-900"
                >
                  info@catchphraser.com
                </a>
                .
              </p>
            </TextSection>

            {/* Team */}
            <section
              id="team"
              className="border-t border-slate-200 bg-white/80 px-5 py-12 backdrop-blur md:px-10 md:py-16"
            >
              <div className="mx-auto max-w-5xl">
                <SectionBadge>Team</SectionBadge>

               
              </div>

              <div className="mx-auto mt-9 grid max-w-6xl gap-6 lg:grid-cols-3">
                {teamMembers.map((member) => (
                  <TeamCard
                    key={member.name}
                    member={member}
                    imageSrc={`${apiBase}/uploads/screens/${member.image}`}
                  />
                ))}
              </div>
            </section>

            {/* Final */}
            <section className="bg-slate-950 px-5 py-12 text-center md:px-10">
              <p className="mx-auto max-w-3xl text-2xl font-black leading-9 text-white md:text-3xl md:leading-10">
                The goal is clearer, more confident speech — not perfection.
              </p>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

const TextSection = ({ badge, title, children, action, tone = 'slate' }) => {
  const isBlue = tone === 'blue';

  return (
    <section className="px-5 py-6 md:px-10 md:py-8">
      <div
        className={`mx-auto max-w-5xl rounded-[32px] border p-5 shadow-sm backdrop-blur md:p-8 ${
          isBlue
            ? 'border-blue-100 bg-blue-50/55'
            : 'border-slate-200 bg-white/88'
        }`}
      >
        <div className="grid gap-7 md:grid-cols-[0.9fr_1.1fr] md:items-start">
          <div>
            <SectionBadge tone={isBlue ? 'blue' : 'slate'}>{badge}</SectionBadge>

            <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-950 md:text-4xl">
              {title}
            </h2>

            {action}
          </div>

          <div className="space-y-5 text-base font-medium leading-8 text-slate-700 md:text-[17px]">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionBadge = ({ children, tone = 'slate' }) => {
  const toneClass =
    tone === 'blue'
      ? 'border-blue-200 bg-white text-blue-700'
      : 'border-slate-200 bg-white text-slate-600';

  return (
    <div
      className={`inline-flex rounded-full border px-3 py-1 text-[11px] font-black uppercase tracking-[0.2em] ${toneClass}`}
    >
      {children}
    </div>
  );
};

const TeamCard = ({ member, imageSrc }) => {
  return (
    <article className="rounded-[30px] border border-slate-200 bg-white/92 p-6 shadow-sm backdrop-blur transition hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-center gap-4">
        <div className="h-20 w-20 shrink-0 overflow-hidden rounded-2xl border border-slate-200 bg-slate-100">
          <img
            src={imageSrc}
            alt={member.name}
            loading="lazy"
            className="h-full w-full object-cover"
            onError={(event) => {
              event.currentTarget.style.display = 'none';
            }}
          />
        </div>

        <div>
          <h3 className="text-lg font-black leading-tight text-slate-950">
            {member.name}
          </h3>

          <p className="mt-1 text-sm font-black text-blue-700">
            {member.role}
          </p>
        </div>
      </div>

      <p className="mt-5 text-sm font-medium leading-6 text-slate-600">
        {member.expertise}
      </p>

      <div className="mt-5 border-t border-slate-100 pt-4">
        <div className="text-[11px] font-black uppercase tracking-[0.18em] text-slate-400">
          Related work
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          {member.projects.map((project) => (
            <a
              key={project.name}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              title={project.description}
              className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-black text-slate-700 no-underline transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
            >
              {project.name}
            </a>
          ))}
        </div>
      </div>
    </article>
  );
};

export default About;